import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { Title } from '../container/LeadManagement/enum';
import { JarvisError } from '../interface';
import { JarvisErrorCodes } from '../container/AddressValidation/enum';
import { WholebuyAccessSupplierType } from '../enum';

/**
 * Check if an object is an ApiErrorResponseWithCode
 * @param {unknown} error - object to check
 * @returns {boolean} - true if the object is an ApiErrorResponseWithCode
 */
export const isApiError = <T>(error: unknown): error is ApiErrorResponseWithCode<T> => {
    return null !== error
        && 'object' === typeof error
        && 'constructor' in error
        && error.constructor.name === ApiErrorResponseWithCode.name;
};

/**
 * Check if an object is a ApiErrorResponseWithCode with its body field being a JarvisError
 * @param {unknown} error - object to check
 * @returns {boolean} - true if the object is an JarvisError
 */
export const isJarvisError = (error: unknown): error is ApiErrorResponseWithCode<JarvisError> => {
    return isApiError<JarvisError>(error)
        && 'body' in error
        && error.body !== null
        && 'errorCode' in error.body
        && Object.values(JarvisErrorCodes).includes(error.body.errorCode as JarvisErrorCodes);
};

export const isGender = (gender?: string): gender is Title =>
    Object.values(Title).includes(gender as Title);

/**
 * Check if access supplier belong to Wholebuy Footprints (DTAG or DGW) .
 *
 * @param {string} accessSupplier - access supplier type to check against.
 * @returns {boolean} True if access supplier type is Wholebuy.
 */

export function isWholebuy(accessSupplier:any):accessSupplier is WholebuyAccessSupplierType{
    return Object?.values(WholebuyAccessSupplierType)?.includes(accessSupplier);
};
